var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGoogleBadge(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 172.12 51",
    width: "172px",
    height: "51px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#a6a6a6;}.cls-10,.cls-2,.cls-3{fill:#fff;}.cls-2{stroke:#fff;stroke-miterlimit:10;stroke-width:0.25px;}.cls-4{fill:url(#linear-gradient);}.cls-5{fill:url(#linear-gradient-2);}.cls-6{fill:url(#linear-gradient-3);}.cls-7{fill:url(#linear-gradient-4);}.cls-8{opacity:0.2;}.cls-10,.cls-8,.cls-9{isolation:isolate;}.cls-9{opacity:0.12;}.cls-10{opacity:0.25;}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 27.79,
    y1: 381.06,
    x2: 6.4,
    y2: 359.66,
    gradientTransform: "matrix(1, 0, 0, -1, 0, 392.16)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00a0ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#00a1ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#00beff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#00d2ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#00dfff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00e3ff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 43.14,
    y1: 366.66,
    x2: 12.29,
    y2: 366.66,
    gradientTransform: "matrix(1, 0, 0, -1, 0, 392.16)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffe000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#ffbd00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "orange"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff9c00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 31.65,
    y1: 363.74,
    x2: 2.64,
    y2: 334.72,
    gradientTransform: "matrix(1, 0, 0, -1, 0, 392.16)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff3a44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c31162"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 9.3,
    y1: 391.94,
    x2: 22.26,
    y2: 378.98,
    gradientTransform: "matrix(1, 0, 0, -1, 0, 392.16)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#32a071"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#2da771"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#15cf74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#06e775"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00f076"
  })))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "google-badge-cta-en") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "artwork"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 172.12,
    height: 51,
    rx: 6.37,
    ry: 6.37
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M165.75,1a5.36,5.36,0,0,1,5.35,5.36V44.63A5.36,5.36,0,0,1,165.75,50H6.37A5.36,5.36,0,0,1,1,44.63V6.38A5.36,5.36,0,0,1,6.37,1H165.75m0-1H6.37A6.4,6.4,0,0,0,0,6.38V44.63A6.39,6.39,0,0,0,6.37,51H165.75a6.39,6.39,0,0,0,6.37-6.37V6.38A6.39,6.39,0,0,0,165.75,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M60.46,13.06a3.45,3.45,0,0,1-1,2.55,3.7,3.7,0,0,1-2.81,1.14,3.94,3.94,0,0,1-4-4,3.94,3.94,0,0,1,4-4,4,4,0,0,1,1.57.32,3.08,3.08,0,0,1,1.19.86l-.67.67a2.58,2.58,0,0,0-2.09-.91,3,3,0,0,0-3,3.06,3,3,0,0,0,3,3.06A2.9,2.9,0,0,0,58.83,15a2.43,2.43,0,0,0,.65-1.55H56.7v-.92h3.7A2.93,2.93,0,0,1,60.46,13.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M66.33,9.87H62.85v2.42H66v.92H62.85v2.42h3.48v.95H61.87V8.93h4.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M70.48,16.58h-1V9.87H67.36V8.93h5.26v.94H70.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M76.42,16.58V8.93h1v7.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M81.76,16.58h-1V9.87H78.64V8.93H83.9v.94H81.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M93.85,15.59a4,4,0,0,1-5.61,0,3.93,3.93,0,0,1-1.12-2.84,3.93,3.93,0,0,1,1.12-2.84,4,4,0,0,1,5.61,0A3.93,3.93,0,0,1,95,12.75,3.94,3.94,0,0,1,93.85,15.59ZM89,15a2.93,2.93,0,0,0,4.15,0,3,3,0,0,0,.85-2.2,3,3,0,0,0-.85-2.2,2.93,2.93,0,0,0-4.15,0,3,3,0,0,0-.85,2.2A3,3,0,0,0,89,15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M96.36,16.58V8.93h1.19l3.72,6h0l0-1.48V8.93h1v7.65h-1l-3.89-6.24h0l0,1.47v4.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M86.87,27.73a5.43,5.43,0,1,0,5.45,5.43A5.34,5.34,0,0,0,86.87,27.73Zm0,8.71a3.29,3.29,0,1,1,3.06-3.28A3.13,3.13,0,0,1,86.87,36.44ZM75,27.73a5.43,5.43,0,1,0,5.44,5.43A5.35,5.35,0,0,0,75,27.73Zm0,8.71a3.29,3.29,0,1,1,3.06-3.28A3.13,3.13,0,0,1,75,36.44Zm-14.13-7v2.3h5.51a4.79,4.79,0,0,1-1.26,2.89,5.63,5.63,0,0,1-4.25,1.69,6.12,6.12,0,0,1,0-12.24A5.83,5.83,0,0,1,65,25.68l1.62-1.62a8,8,0,0,0-5.77-2.32,8.42,8.42,0,1,0,0,16.84,7.71,7.71,0,0,0,5.88-2.36,7.61,7.61,0,0,0,2-5.39,7.64,7.64,0,0,0-.12-1.43Zm57.77,1.78A5,5,0,0,0,114,27.73a5.16,5.16,0,0,0-5.12,5.43,5.31,5.31,0,0,0,5.39,5.42,5.38,5.38,0,0,0,4.51-2.4l-1.84-1.24a3.09,3.09,0,0,1-2.67,1.5,2.74,2.74,0,0,1-2.63-1.64l7.25-3ZM111.25,33a3,3,0,0,1,2.83-3.16,2.08,2.08,0,0,1,2,1.15Zm-5.9,5.26h2.38V22.31h-2.38Zm-3.9-9.3h-.08a3.78,3.78,0,0,0-2.86-1.22,5.43,5.43,0,0,0,0,10.85,3.75,3.75,0,0,0,2.86-1.23h.08v.78c0,2.07-1.11,3.18-2.9,3.18a3,3,0,0,1-2.73-1.93l-2.07.86a5.15,5.15,0,0,0,4.8,3.21c2.8,0,5.16-1.65,5.16-5.65V28.06h-2.26Zm-2.73,7.49a3.1,3.1,0,0,1-3-3.26,3.14,3.14,0,0,1,3-3.31,3.06,3.06,0,0,1,2.89,3.31A3,3,0,0,1,98.72,36.44ZM129.8,22.31h-5.7V38.25h2.38v-6h3.32a5,5,0,1,0,0-9.9Zm.06,7.68h-3.38V24.53h3.38a2.73,2.73,0,1,1,0,5.46Zm14.71-2.29a4.47,4.47,0,0,0-4.25,2.44l2.11.89a2.25,2.25,0,0,1,2.18-1.17,2.29,2.29,0,0,1,2.5,2.05v.16a5.33,5.33,0,0,0-2.48-.61c-2.28,0-4.6,1.25-4.6,3.59a3.68,3.68,0,0,0,4,3.5A3.37,3.37,0,0,0,147,37h.08v1.23h2.3V32.11C149.41,29.28,147.29,27.7,144.57,27.7Zm-.29,8.74c-.78,0-1.87-.39-1.87-1.35,0-1.23,1.36-1.71,2.53-1.71a4.22,4.22,0,0,1,2.17.54A2.89,2.89,0,0,1,144.28,36.44Zm13.49-8.39L155,35H155l-2.83-6.91h-2.56l4.24,9.66-2.42,5.37h2.49l6.54-15Zm-21.43,10.2h2.38V22.31h-2.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M13.3,9.61a2.55,2.55,0,0,0-.59,1.79V39.6a2.55,2.55,0,0,0,.59,1.79l.1.09L29.2,25.69v-.38L13.4,9.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M34.46,31,29.2,25.69v-.38l5.26-5.26.12.07,6.24,3.54c1.78,1,1.78,2.67,0,3.68l-6.24,3.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M34.58,30.89,29.2,25.5,13.3,41.39a2.08,2.08,0,0,0,2.65.08L34.58,30.89"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M34.58,20.12,16,9.53a2.08,2.08,0,0,0-2.65.08L29.2,25.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M34.46,30.77,16,41.28a2.12,2.12,0,0,1-2.55,0h0l-.1.09h0l.1.09h0a2.11,2.11,0,0,0,2.55,0L34.58,30.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M13.3,41.21a2.59,2.59,0,0,1-.59-1.8v.19a2.55,2.55,0,0,0,.59,1.79l.1-.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M40.82,27.16l-6.36,3.61.12.12,6.24-3.55a2.22,2.22,0,0,0,1.33-1.84h0A2.36,2.36,0,0,1,40.82,27.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M16,9.72,40.82,23.85a2.35,2.35,0,0,1,1.33,1.65h0a2.21,2.21,0,0,0-1.33-1.84L16,9.53c-1.78-1-3.24-.17-3.24,1.87v.19C12.71,9.55,14.17,8.71,16,9.72Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleBadge);
export default __webpack_public_path__ + "static/media/google-badge.dbacd962b65a1199bf43e5631aba2d72.svg";
export { ForwardRef as ReactComponent };